import { ALL_SCREENS, SCREEN_LABELS, type Screen } from '../lib/types'

interface Props {
  selected: Screen[]
  onChange: (screens: Screen[]) => void
}

export default function ScreenSelector({ selected, onChange }: Props) {
  const selectedSet = new Set(selected)

  function toggle(screen: Screen) {
    const next = new Set(selectedSet)
    if (next.has(screen)) next.delete(screen)
    else next.add(screen)
    // Preserve canonical screen order.
    onChange(ALL_SCREENS.filter((s) => next.has(s)))
  }

  return (
    <div className="card">
      <h2>Ethical screens</h2>
      <p className="muted">Choose which activities to measure exposure to.</p>
      <div className="screen-chips">
        {ALL_SCREENS.map((screen) => {
          const active = selectedSet.has(screen)
          return (
            <label key={screen} className={`chip ${active ? 'chip-active' : ''}`}>
              <input
                type="checkbox"
                checked={active}
                onChange={() => toggle(screen)}
              />
              {SCREEN_LABELS[screen]}
            </label>
          )
        })}
      </div>
    </div>
  )
}
